module.exports = {"140971100":"台怀镇","140971200":"金岗库乡","140971201":"石咀乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140971.json
// module id = 359
// module chunks = 0